module.exports = __webpack_public_path__ + "img/web_pic_feature2.fc6e483f.png";